import Account from './Account.svelte';
import Admin from './Admin.svelte';
import AdminLogs from './AdminLogs.svelte';
import AdminSettings from './AdminSettings.svelte';
import AdminSMTP from './AdminSMTP.svelte';
import AdminSecurity from './AdminSecurity.svelte';
import AdminEmailTemplates from './AdminEmailTemplates.svelte';
import AccountApplications from './AccountApplications.svelte';
import AccountNotifications from './AccountNotifications.svelte';
import AccountSessions from './AccountSessions.svelte';
import AccountPasskeys from './AccountPasskeys.svelte';
import AdminLicensing from './AdminLicensing.svelte';
import AdminUserDashboard from './AdminUserDashboard.svelte';
import AdminDashboard from './AdminDashboard.svelte';
import AdminMetrics from './AdminMetrics.svelte';
import AdminTokenExport from './AdminTokenExport.svelte';
import AdminSupport from './AdminSupport.svelte';

/** Settings sub-route map — URL patterns to settings page components. */
export default {
	'/Settings': Account,
	'/Settings/Account': Account,
	'/Settings/Account/Notifications': AccountNotifications,
	'/Settings/Account/Applications': AccountApplications,
	'/Settings/Account/Sessions': AccountSessions,
	'/Settings/Account/Passkeys': AccountPasskeys,
	'/Settings/Admin': Admin,
	'/Settings/Admin/Logs': AdminLogs,
	'/Settings/Admin/General': AdminSettings,
	'/Settings/Admin/SMTP': AdminSMTP,
	'/Settings/Admin/Security': AdminSecurity,
	'/Settings/Admin/EmailTemplates': AdminEmailTemplates,
	'/Settings/Admin/Licensing': AdminLicensing,
	'/Settings/Admin/Support': AdminSupport,
	'/Settings/Admin/UserDashboard': AdminUserDashboard,
	'/Settings/Admin/Dashboard': AdminDashboard,
	'/Settings/Admin/Metrics': AdminMetrics,
	'/Settings/Admin/TokenExport': AdminTokenExport
};
